import React, { useEffect, useState } from "react";
import styled from "styled-components";
import "./Footer.css";
import IndieLogo from '../assets/indieLogo2.png'
import MemberLogo from '../assets/memberLogo2.png'
import FbBlackIcon from '../assets/fbBlackIcon.png'
import BottomToTop from '../assets/bottomToTop.png'
import FooterPlayStore from '../assets/new_footer_playstore.png'
import FooterAppStore from '../assets/new_footer_appstore.png'
import { useNavigate } from "react-router-dom";
import { BASE_URL, get } from "../services/Calls";

const Footer = () => {
  const navigate = useNavigate();
  const [mobileView, setMobileView] = useState<boolean>(
    window.innerWidth <= 768
  );

  useEffect(() => {
    getCountries()
    function updateSize() {
      if (window.innerWidth <= 768) setMobileView(true);
      else setMobileView(false);
    }
    window.addEventListener("resize", updateSize);
  }, [mobileView]);


  const handleScrollUpClick = (event: any) => {
    window.scrollTo(0, 0);
  };
  const [countryData, setCountryData]: any = useState([])
  const getCountries = async () => {
        try{
        const response = await get(BASE_URL + '/countries?order=ASC')
        if (response && response.length > 0) {
            setCountryData(response)
        }
    }
    catch(ex){
        //alert(ex)
console.log('error',ex)
    }
    }


  return (
    <>
      <Container>
        <div className="footerLogoMainDiv">
          <div className="footerLogoFirstDiv">
            <img className="footerLogoFirstLogo" src={IndieLogo} alt="" />
            <img className="footerLogoSecondLogo" src={MemberLogo} alt="" />
          </div>
          <a href="https://www.facebook.com/profile.php?id=61576034056586" target="_blank" rel="noreferrer" >
            <img className="footerLogoFbLogo"  src={FbBlackIcon} alt="" /></a>
          
        </div>
            <div
            className="mainFooterItemDiv"
            >
              <div className="row new_footer_row">
                <div
                  className="col-lg-10 col-md-12 col-sm-12 new_footer_grid_box"
                  style={{ padding: 0 }}
                >
                  <div className="new_footer_item_box">
                    <div className="new_footer_item_head">Company</div>
                    <div
                      className="new_footer_item"
                      onClick={() => navigate("/OurStory")}
                    >
                      Our Story
                    </div>
                   
                    <div
                      className="new_footer_item"
                      onClick={() => navigate("/HowItWorks")}
                    >
                      How it works
                    </div>
                    <div
                      className="new_footer_item"
                      onClick={() =>navigate("/OurTeam")}
                    >
                      Our team
                    </div>
                    <div
                      className="new_footer_item"
                      onClick={() => navigate("/Sustainability")}
                    >
                      Sustainability
                    </div>
                  </div>
                
                  <div className="new_footer_item_box">
                    <div className="new_footer_item_head">Destination</div>


                    {countryData && countryData.length > 0 && countryData.slice(0, 7).map((country: any, index: any) => (

                                    <div
                                    className="new_footer_item"
                                    onClick={()=>{
                                      navigate('/'+country.name,{state:{country:country}}) 
                                    }}
                                  >
                                    {country.name}
                                  </div>
                                ))}

              
                 
                  </div>
                  {countryData && countryData.length > 0 &&   
                  <div className="new_footer_item_box">
                    <div className="new_footer_item_head">Destination</div>


                    {countryData && countryData.length > 0 && countryData.slice(7, 20).map((country: any, index: any) => (

                                    <div
                                    className="new_footer_item"
                                    onClick={()=>{
                                      navigate('/'+country.name,{state:{country:country}}) 
                                    }}
                                  >
                                    {country.name}
                                  </div>
                                ))}

              
                 
                  </div>
}
               
                  <div className="new_footer_item_box">
                    <div className="new_footer_item_head">Legal</div>
                    <div
                      className="new_footer_item"
                      onClick={()=>{navigate('/PrivacyPolicy')}}
                    >
                      Privacy policy
                    </div>
                    <div
                      className="new_footer_item"
                      onClick={()=>{navigate('/TermsOfUse')}}
                    >
                      Terms of use
                    </div>
                    <div
                      className="new_footer_item"
                      onClick={()=>{navigate('/TermsAndConditions')}}
                    >
                      Terms and conditions
                    </div>
                   {/*  <div
                      className="new_footer_item"
                      onClick={()=>{navigate('/SiteMap')}}
                    >
                      Site map
                    </div> */}
                  </div>
                  <div className="new_footer_item_box">
                    <div className="new_footer_item_head">Support</div>
                    <div
                      className="new_footer_item"
                      onClick={()=>{navigate('/CancellationPolicy')}}
                      
                    >
                      Cancellation policy
                    </div>
                    <div className="new_footer_item" onClick={()=>{navigate('/ContactUs')}}>
                    Contact us
                    </div>  
                    
                  </div>
                 
                </div>



                <div className="col-lg-2 col-md-12 col-sm-12 ">

                </div>
              </div>
              <img
                src={BottomToTop}
                onClick={handleScrollUpClick}
                className="new_back_to_top"
                alt=""
              />
            </div>
            <div className="footerCopyRightDiv">
              <div className="footerStoreLinks footerCopyRightSide">
                <a
                  href="https://play.google.com/store/apps/details?id=com.indie4x4&hl=en"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={FooterPlayStore} alt="Get it on Google Play" />
                </a>
                <a
                  href="https://apps.apple.com/us/app/indie-4x4-by-medraft/id6736527831"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={FooterAppStore} alt="Download on the App Store" />
                </a>
              </div>
              <span className="footerCopyRightText">© Copyright 2024, iNDiE</span>
              <div className="footerCopyRightSide" />
            </div>
          
      </Container>

    </>
  );
};

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: #F8F8F6;
`;

export default Footer;
